import { NumberParam, useQueryParam } from 'use-query-params';
import { NumberInput } from '../../../../components/shared/input/Input';
import { QueryParamNames } from '../../enums/QueryParamNames';

export default function EnjoymentFilter() {
    const [minEnjoyment, setMinEnjoyment] = useQueryParam(QueryParamNames.MIN_ENJOYMENT, NumberParam);
    const [maxEnjoyment, setMaxEnjoyment] = useQueryParam(QueryParamNames.MAX_ENJOYMENT, NumberParam);

    return (
        <div className='col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2'>
            <p>Enjoyment:</p>
            <div className='flex items-center'>
                <NumberInput min='0' max='10' value={minEnjoyment ?? null} onChange={setMinEnjoyment} />
                <p className='m-0 mx-2'>to</p>
                <NumberInput min='0' max='10' value={maxEnjoyment ?? null} onChange={setMaxEnjoyment} />
            </div>
        </div>
    );
}
